<template>
    <div class="externalEmailComponent px-8 pt-4" style="height:100%;">
        <h2 style="font-size: 20px;" class="mb-6">{{ $t('sourceEmail') }}</h2>
        <h5 style="font-size: 17px;" class="primary--text mb-2">{{  $t('details') }}</h5>
        <div class="mb-1" v-if="emailData.subject">
            <b>{{ $t('object') }} : </b>{{emailData.subject}}
        </div>
        <div class="mb-1" v-if="emailData.received_at">
            <b>{{ $t('received_at') }} : </b>{{emailData.received_at}}
        </div>
        <div class="mb-1" v-if="emailData.from">
            <b>{{ $t('expediteur') }} : </b>{{emailData.from}}
        </div>
        <div class="mb-1" v-if="emailData.to">
            <b>{{ $t('destinataire') }} : </b>{{emailData.to}}
        </div>
        <div class="mb-1" v-if="emailData.parser_name">
            <b>{{ $t('parser_name') }} : </b>{{emailData.parser_name}}
        </div>
        <iframe class="mt-3" :src="$store.state.auth.apiUrl+'/ns/superlead/getHtmlExternalEmail?id='+emailData.lead_id+'&account_id='+$store.state.auth.currentAccountId" frameborder="0" style="width:100%; height:70%">
            {{ emailData.html }}
        </iframe>
    </div>
</template>
<script>
export default {
    name: "externalEmailPreviewComponent",
    props: ["emailData"],
    data() {
        return {
            
        }
    },
    computed: {
        
    },
    methods: {
        
    },
}
</script>